// const SERVER_IP = 'goodi4u.com'
const SERVER_IP = 'gibadugi.com'
module.exports = {
  SERVER_IP,
}
